
export default {
    menuButton : null,
    navigationElement : null,

    init() {
        this.menuButton = document.getElementsByClassName('hamburger')[0];
        this.navigationElement = document.getElementById('menu-main-navigation');

        this.menuButton.addEventListener('click', () => {
            this.toggleMenuButton();
            this.toggleNavigationVisibility();
        });

        window.addEventListener('scroll', () => this.toggleHeaderState());
    },

    toggleHeaderState() {
        if(window.scrollY > 56) {
            document.getElementById('site-header').classList.add('scrolled');
        } else {
            document.getElementById('site-header').classList.remove('scrolled');
        }
    },

    toggleMenuButton() {
        this.menuButton.classList.toggle('is-active');
    },
    toggleNavigationVisibility() {
        this.navigationElement.classList.toggle('is-active');
    }
}
